import PageHero from "../../components/sections/PageHero";
import GoldButton from "../../components/ui/GoldButton";
import SectionLabel from "../../components/ui/SectionLabel";

const cityItems = ["Delhi NCR (HQ)", "Mumbai", "Bangalore", "Pune", "Hyderabad", "Chennai"];

const IndiaIndex = () => (
  <>
    <PageHero
      label="INDIA HUB"
      title="India's full-stack"
      titleAccent="technology partner."
      subtitle="Headquartered in Delhi, India. GST-compliant, DPDP-aware systems for Indian businesses with national delivery coverage."
    />

    <section style={{ background: "#050505", padding: "0 0 120px" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 32 }}>
          {["Delhi NCR", "Mumbai", "Bangalore", "Pune", "Pan-India delivery"].map((chip) => (
            <span key={chip} style={{ padding: "9px 14px", border: "1px solid rgba(212,168,67,0.24)", borderRadius: 3, fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#D4A843", background: "rgba(212,168,67,0.06)" }}>
              {chip}
            </span>
          ))}
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: 24,
            marginBottom: 36,
          }}
        >
          {[
            "GST-compliant, DPDP Act, Tally integration standard",
            "WhatsApp Business API native · Hindi + regional language AI · UPI + Razorpay/PayU",
                        "Indian business culture and regulatory landscape familiarity",
          ].map((item) => (
            <div key={item} style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 26, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.8 }}>
              {item}
            </div>
          ))}
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 24, marginBottom: 36 }}>
          {[
            { label: "MSMEs in India", value: "63M+" },
            { label: "IT market by 2026", value: "₹4.5L Cr" },
            { label: "Businesses planning AI in 2025", value: "40%" },
            { label: "Advocates with dedicated tech", value: "<3%" },
          ].map((item) => (
            <div key={item.label} style={{ background: "#1A1208", border: "1px solid rgba(212,168,67,0.22)", borderRadius: 4, padding: 26 }}>
              <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 36, color: "#D4A843", lineHeight: 1 }}>{item.value}</div>
              <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#F8F4EC", marginTop: 8 }}>{item.label}</div>
            </div>
          ))}
        </div>

        <div style={{ marginBottom: 36 }}>
          <SectionLabel text="CITIES" />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 16, marginTop: 22 }}>
            {cityItems.map((city) => (
              <div key={city} style={{ padding: "18px 20px", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, background: "#0E0E0E", fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC" }}>
                {city}
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 20, marginBottom: 42 }}>
          {[
            { title: "Mumbai City Page", desc: "Serving Mumbai businesses through structured delivery from our Delhi HQ.", href: "/india/mumbai" },
            { title: "UAE Page", desc: "Technology and AI services for UAE businesses, billed in AED.", href: "/uae" },
            { title: "UK Page", desc: "Reliable software and AI delivery for UK businesses .", href: "/uk" },
          ].map((item) => (
            <a key={item.title} href={item.href} style={{ display: "block", padding: 24, background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, textDecoration: "none" }}>
              <div style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300, fontSize: 26, color: "#F8F4EC", marginBottom: 8 }}>{item.title}</div>
              <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#908A83", lineHeight: 1.7 }}>{item.desc}</div>
            </a>
          ))}
        </div>

        <div style={{ textAlign: "center" }}>
          <GoldButton href="/contact">WORK WITH OWL</GoldButton>
        </div>
      </div>
    </section>
  </>
);

export default IndiaIndex;
